import { getValue } from '../helpers/StringHelpers'

const allDetails = {
  'Basic Information': ['brand', 'model', 'model_no', 'case_size_mm', 'serial_number', 'age'],
  'Key Features': ['features', 'movement', 'original_box:1', 'booklets:1', 'original_papers:1'],
  Case: [
    'dial_style',
    'dial',
    'head_metal',
    'case_thickness',
    'case_size_mm',
    'lug_to_lug_length',
    'case_length',
    'case_shape',
    'case_back',
    'bezel_material',
  ],
  'Band / Strap': [
    'band_metal',
    'band_style',
    'band_color',
    'band_width',
    'band_length',
    'band_size',
    'band_type',
    'buckle_style',
    'buckle_material',
  ],
  Other: [
    'gender',
    'watch_style',
    'warranty',
    'condition',
    'size',
    'width',
    'length',
    'metals',
    'original_box:0',
    'booklets:0',
    'original_papers:0',
    'item_weight',
    'stones'
  ],
}

const isEligible = (info, keyValue) => {
  const [key, ...expectedValues] = keyValue.split(':')
  const value = info[key]
  const formattedValue = getValue(key, value)
  let isNotEmpty = false
  if (value && value !== '' && value !== 'N/A' && value !== 'NA' && 
    formattedValue && formattedValue !== '' && formattedValue !== 'N/A' && formattedValue !== 'NA') {
    isNotEmpty = true
  }
  if (expectedValues.length > 0) {
    return isNotEmpty && expectedValues.includes(value.toString())
  }
  return isNotEmpty
}

const getProductDetails = product => {
  const attributes = {}
  const unstructured = []
  let categories = Object.keys(allDetails)
  for (const category of categories) {
    let details = allDetails[category]
    for (const detail of details) {
      const [key] = detail.split(':')
      if (isEligible(product, detail)) {
        attributes[category] = attributes[category] || []
        attributes[category].push(key)
        unstructured.push(key)
      }
    }
  }
  if(Object.keys(attributes).length <= 3 && unstructured.length <= 10) {
    return { attributes: {
      'Basic Information': Object.keys(attributes).map(key => attributes[key]).flat(),
    }, unstructured }
  }
  return { attributes, unstructured }

  //   for (const prop of allDetails) {
  //     if (
  //       C
  //     ) {
  //       attributes.push(prop)
  //     }
  //   }
  //   return attributes
}

export { allDetails, getProductDetails }
